<!--begin::Logo image-->
<!-- Redirect target kept for restore: routerLink="/settings/study-period" -->
<a class="enku-sidebar-brand">
  <img
    alt="ENKKU"
    src="./assets/media/logos/landing-dark.svg"
    class="app-sidebar-logo-default enku-sidebar-logo"
  />

  <img
    alt="ENKKU"
    src="./assets/media/logos/landing-dark.svg"
    class="app-sidebar-logo-minimize enku-sidebar-logo-minimize"
  />
</a>
<!--end::Logo image-->

@if (toggleEnabled) {
  <!--begin::Sidebar toggle-->
  <button
    type="button"
    id="kt_app_sidebar_toggle"
    class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate rounded-circle"
    [ngClass]="toggleButtonClass"
    data-kt-toggle="true"
    [attr.data-kt-toggle-state]="toggleState"
    data-kt-toggle-target="body"
    [attr.data-kt-toggle-name]="toggleAttr"
    (click)="toggleClick()"
  >
    <app-keenicon
      name="double-left"
      class="fs-2 rotate-180  {{
        isToggle ? 'rotate-active ' : 'rotate-back ms-n1'
      }}"
    ></app-keenicon>
  </button>
  <!--end::Sidebar toggle-->
}
